import Vue from 'vue'
import VueRouter from 'vue-router'
import routerPC from './routerPC'
import routerM from './routerM'

Vue.use(VueRouter)


// const routesList = [
//   {
//     path: '/',
//     redirect: '/home',
//   },
//   {
//     path: '/home',
//     name: '天科首页',
//     components: {
//       pc: () => import('../views/HomeView'),
//       m: () => import('../views/mobile/m_HomeView'),
//     },
//     meta: {
//       active: '天科首页',
//     }
//   },
//   {
//     path: '/company',
//     name: '公司简介',
//     components: {
//       pc: () => import('../views/CompanyView'),
//       m: () => import('../views/CompanyView'),
//     },
//     meta: {
//       active: '公司简介',
//       navShow: true
//     }
//   },
//   {
//     path: '/product',
//     name: '产品展示',
//     component:
//     {
//       pc:() => import('../views/ProductView') ,
//       m: () => import('../views/ProductView')
//     },
//     children: [
//       {
//         path: '/product/pcb',
//         name: '线路板产品',
//         components: {
//           pc: () => import('../views/pcbView'),
//           m: () => import('../views/pcbView')
//         },
//         meta: {
//           active: '线路板产品',
//           navShow: true
//         }
//       },
//       {
//         path: '/product/NE',
//         name: '新能源产品',
//         components: {
//           pc: () => import('../views/neView'),
//           m: () => import('../views/neView')
//         },
//         meta: {
//           active: '新能源产品',
//           navShow: true
//         }
//       },
//     ],
//     meta: {
//       active: '产品展示',
//       navShow: true
//     },
//   },
//   {
//     path: '/serve',
//     name: '产品服务',
//     components: {
//       pc: () => import('../views/ServeView'),
//       m: () => import('../views/ServeView'),
//     },
//     meta: {
//       active: '产品服务',
//       navShow: true
//     }
//   },
//   {
//     path: '/credit',
//     name: '证书资质',
//     components: {
//       pc: () => import('../views/CreditView'),
//       m: () => import('../views/CreditView'),
//     },
//     meta: {
//       active: '证书资质',
//       navShow: true
//     }
//   },
//   {
//     path: '/news',
//     name: '新闻中心',
//     components: {
//       pc: () => import('../views/NewsList'),
//       m: () => import('../views/NewsList')
//     },
//     meta: {
//       active: '新闻中心',
//       navShow: true
//     }
//   },
//   {
//     path: '/cooperate',
//     name: '合作伙伴',
//     components: {
//       pc: () => import('../views/CooperateView'),
//       m: () => import('../views/CooperateView'),
//     },
//     meta: {
//       active: '合作伙伴',
//       navShow: true
//     }
//   },
//   {
//     path: '/connect',
//     name: '联系我们',
//     components: {
//       pc: () => import('../views/ConnectView'),
//       m: () => import('../views/ConnectView')
//     },
//     meta: {
//       active: '联系我们',
//       navShow: true
//     }
//   },
//   {
//     path: '/detail',
//     name: '产品详情',
//     components: {
//       pc: () => import('../views/PcbDetail'),
//       m: () => import('../views/PcbDetail')
//     },
//   },
//   {
//     path: '/news/detail',
//     name: '新闻中心',
//     components: {
//       pc: () => import('../views/NewsDetail'),
//       m: () => import('../views/NewsDetail')
//     },
//   }
// ]

const ISMOBILE = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
  };

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // routes: routesList
  routes: ISMOBILE() ? routerM : routerPC,
})

export default router
